import libphonenumber, { PhoneNumberFormat } from "google-libphonenumber";

export const defaultSite = {
  label: "Default Site",
  value: {
    locId: "default-000",
    questionnaireId: "questionnaire-default-000",
  },
};

export const sitesRelatedData = [
  {
    locationName: "Corporate Site",
    city: "San Antonio",
    locationId: "37b9ea93-649b-41f0-b080-26c809684bce",
    questionnaireId: "bb77ed07-4b05-44d8-afcb-333dcacf5d2a",
    study: "COPD",
    studies:["COPD", "Gout"],
    questionnaire: {
      id: "bb77ed07-4b05-44d8-afcb-333dcacf5d2a",
      identifier: [
        {
          system: "http://clinical_trial_agent.com",
          value: "orie-devs-o7p2k-clinical-trial-agent",
        },
      ],
      item: [
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString: "¿Cuál es su nombre completo?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString: "Por favor, escriba su nombre y apellido.",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString: "Please enter your first and last name.",
            },
          ],
          linkId: "subject-fullName",
          text: "What is your full name?",
          type: "string",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString: "¿Cuál es su fecha de nacimiento?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString: "MM / DD / AAAA",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString: "MM / DD / YYYY",
            },
          ],
          linkId: "subject-dateOfBirth",
          text: "What is your date of birth?",
          type: "date",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString:
                      "¿Cuál es su dirección y ciudad (según aparece en su identificación válida)?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString:
                    "Por favor, proporcione su dirección y ciudad tal como aparece en su identificación válida.",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString:
                "Please provide your street address and city as listed on your valid ID.",
            },
          ],
          linkId: "subject-address-streetAndCity",
          text: "What is your Street address and City (as listed on valid ID)?",
          type: "string",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString: "¿Cuál es su estado?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString: "Por favor, proporcione el nombre de su estado.",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString: "Please provide the name of your state.",
            },
          ],
          linkId: "subject-address-state",
          text: "What is your State?",
          type: "string",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString: "¿Cuál es su código postal?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString: "Por favor, proporcione su código postal.",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString: "Please provide your zip code.",
            },
          ],
          linkId: "subject-address-zipCode",
          text: "What is your Zip Code?",
          type: "string",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString: "¿Está tomando algún medicamento actualmente?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString:
                    "Por favor, escriba todos los medicamentos que toma, incluyendo recetas y medicamentos de venta libre.",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString:
                "Please list all prescription and over-the-counter medications you are taking.",
            },
          ],
          linkId: "subject-medications-currentMedications",
          text: "Are you currently taking any medications?",
          type: "text",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString:
                      "¿Ha visitado un hospital o sala de emergencias recientemente?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString:
                    "Indique si ha visitado un hospital o sala de emergencias recientemente.",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString:
                "Indicate if you have visited a hospital or emergency room recently.",
            },
          ],
          linkId: "subject-hospitalVisits-recentVisit-or-emergencyRoom",
          text: "Have you visited a hospital or emergency room recently?",
          type: "boolean",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString: "¿Le han diagnosticado EPOC?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          linkId: "subject-location-specific-medical-condition-copd",
          text: "Have you been diagnosed with COPD?",
          type: "string",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString: "¿Le han diagnosticado gota?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          linkId: "subject-location-specific-medical-condition-gout",
          text: "Have you been diagnosed with Gout?",
          type: "string",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString:
                      "¿Tiene alguna condición de salud actual o pasada? (Si le han diagnosticado cáncer, por favor especifique el estadio)",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString:
                    "Incluya condiciones crónicas (por ejemplo, diabetes, asma) y condiciones recientes o agudas (por ejemplo, infecciones, cirugías).",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString:
                "Include both chronic (e.g., diabetes, asthma) and recent or acute conditions (e.g., infections, surgeries).",
            },
          ],
          linkId: "subject-healthConditions-currentOrPastConditions",
          text: "Do you have any current or past health conditions? (If you have been diagnosed with cancer, please specify the stage)",
          type: "text",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString:
                      "¿Le gustaría programar una cita con nosotros?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString:
                    "Indíquenos si le gustaría programar una consulta médica.",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString:
                "Let us know if you'd like to set up a consultation.",
            },
          ],
          linkId: "subject-appointment-requestAppointment",
          text: "Would you like to schedule an appointment with us?",
          type: "boolean",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString:
                      "Si es así, por favor proporcione una fecha y hora para la cita",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          enableWhen: [
            {
              answerBoolean: true,
              operator: "=",
              question: "subject-appointment-requestAppointment",
            },
          ],
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString:
                    "Proporcione la fecha y hora preferidas para la cita.",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString: "Specify the date and time you are available.",
            },
          ],
          linkId: "subject-appointment-preferredDateTime",
          text: "If yes, please provide a date and time for the appointment",
          type: "dateTime",
        },
      ],
      meta: {
        extension: [
          {
            url: "http://enliv.com/extensions/meta/user-info",
            valueString:
              '{"uid":"XRR8CdfmkIeBpWtIXt0yg3WoECS2","name":"Orie Devs","email":"dev.orie@yopmail.com"}',
          },
        ],
        lastUpdated: "2025-11-21T10:53:18.620025+00:00",
        source: "XRR8CdfmkIeBpWtIXt0yg3WoECS2",
        tag: [
          {
            code: "Location/37b9ea93-649b-41f0-b080-26c809684bce",
            system: "http://clinical_trial_agent.com/tags/location",
          },
        ],
        versionId: "MTc2MzcyMjM5ODYyMDAyNTAwMA",
      },
      name: "clinical_trial_questionnaire",
      resourceType: "Questionnaire",
      status: "active",
      title: "Discovery Clinical Trials Intake Form",
      url: "http://example.org/fhir/Questionnaire/clinical_trial_form/dev/1",
      version: "001",
    },
  },
  {
    locationName: "Corporate Site",
    city: "San Antonio",
    locationId: "37b9ea93-649b-41f0-b080-26c809684bce",
    questionnaireId: "bb77ed07-4b05-44d8-afcb-333dcacf5d2a",
    study: "Gout",
    studies:["COPD", "Gout"],
    questionnaire: {
      id: "bb77ed07-4b05-44d8-afcb-333dcacf5d2a",
      identifier: [
        {
          system: "http://clinical_trial_agent.com",
          value: "orie-devs-o7p2k-clinical-trial-agent",
        },
      ],
      item: [
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString: "¿Cuál es su nombre completo?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString: "Por favor, escriba su nombre y apellido.",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString: "Please enter your first and last name.",
            },
          ],
          linkId: "subject-fullName",
          text: "What is your full name?",
          type: "string",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString: "¿Cuál es su fecha de nacimiento?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString: "MM / DD / AAAA",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString: "MM / DD / YYYY",
            },
          ],
          linkId: "subject-dateOfBirth",
          text: "What is your date of birth?",
          type: "date",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString:
                      "¿Cuál es su dirección y ciudad (según aparece en su identificación válida)?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString:
                    "Por favor, proporcione su dirección y ciudad tal como aparece en su identificación válida.",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString:
                "Please provide your street address and city as listed on your valid ID.",
            },
          ],
          linkId: "subject-address-streetAndCity",
          text: "What is your Street address and City (as listed on valid ID)?",
          type: "string",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString: "¿Cuál es su estado?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString: "Por favor, proporcione el nombre de su estado.",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString: "Please provide the name of your state.",
            },
          ],
          linkId: "subject-address-state",
          text: "What is your State?",
          type: "string",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString: "¿Cuál es su código postal?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString: "Por favor, proporcione su código postal.",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString: "Please provide your zip code.",
            },
          ],
          linkId: "subject-address-zipCode",
          text: "What is your Zip Code?",
          type: "string",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString: "¿Está tomando algún medicamento actualmente?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString:
                    "Por favor, escriba todos los medicamentos que toma, incluyendo recetas y medicamentos de venta libre.",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString:
                "Please list all prescription and over-the-counter medications you are taking.",
            },
          ],
          linkId: "subject-medications-currentMedications",
          text: "Are you currently taking any medications?",
          type: "text",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString:
                      "¿Ha visitado un hospital o sala de emergencias recientemente?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString:
                    "Indique si ha visitado un hospital o sala de emergencias recientemente.",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString:
                "Indicate if you have visited a hospital or emergency room recently.",
            },
          ],
          linkId: "subject-hospitalVisits-recentVisit-or-emergencyRoom",
          text: "Have you visited a hospital or emergency room recently?",
          type: "boolean",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString: "¿Le han diagnosticado EPOC?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          linkId: "subject-location-specific-medical-condition-copd",
          text: "Have you been diagnosed with COPD?",
          type: "string",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString: "¿Le han diagnosticado gota?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          linkId: "subject-location-specific-medical-condition-gout",
          text: "Have you been diagnosed with Gout?",
          type: "string",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString:
                      "¿Tiene alguna condición de salud actual o pasada? (Si le han diagnosticado cáncer, por favor especifique el estadio)",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString:
                    "Incluya condiciones crónicas (por ejemplo, diabetes, asma) y condiciones recientes o agudas (por ejemplo, infecciones, cirugías).",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString:
                "Include both chronic (e.g., diabetes, asthma) and recent or acute conditions (e.g., infections, surgeries).",
            },
          ],
          linkId: "subject-healthConditions-currentOrPastConditions",
          text: "Do you have any current or past health conditions? (If you have been diagnosed with cancer, please specify the stage)",
          type: "text",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString:
                      "¿Le gustaría programar una cita con nosotros?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString:
                    "Indíquenos si le gustaría programar una consulta médica.",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString:
                "Let us know if you'd like to set up a consultation.",
            },
          ],
          linkId: "subject-appointment-requestAppointment",
          text: "Would you like to schedule an appointment with us?",
          type: "boolean",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString:
                      "Si es así, por favor proporcione una fecha y hora para la cita",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          enableWhen: [
            {
              answerBoolean: true,
              operator: "=",
              question: "subject-appointment-requestAppointment",
            },
          ],
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString:
                    "Proporcione la fecha y hora preferidas para la cita.",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString: "Specify the date and time you are available.",
            },
          ],
          linkId: "subject-appointment-preferredDateTime",
          text: "If yes, please provide a date and time for the appointment",
          type: "dateTime",
        },
      ],
      meta: {
        extension: [
          {
            url: "http://enliv.com/extensions/meta/user-info",
            valueString:
              '{"uid":"XRR8CdfmkIeBpWtIXt0yg3WoECS2","name":"Orie Devs","email":"dev.orie@yopmail.com"}',
          },
        ],
        lastUpdated: "2025-11-21T10:53:18.620025+00:00",
        source: "XRR8CdfmkIeBpWtIXt0yg3WoECS2",
        tag: [
          {
            code: "Location/37b9ea93-649b-41f0-b080-26c809684bce",
            system: "http://clinical_trial_agent.com/tags/location",
          },
        ],
        versionId: "MTc2MzcyMjM5ODYyMDAyNTAwMA",
      },
      name: "clinical_trial_questionnaire",
      resourceType: "Questionnaire",
      status: "active",
      title: "Discovery Clinical Trials Intake Form",
      url: "http://example.org/fhir/Questionnaire/clinical_trial_form/dev/1",
      version: "001",
    },
  },
  {
    locationName: "Stone Oak Site",
    city: "San Antonio",
    locationId: "d587f831-b0b9-4f49-816d-814167fa57b4",
    questionnaireId: "6f090a20-04e5-41c9-97a2-771bf856b53e",
    study: "Eczema",
    studies: ["Pediatric Migraine", "Eczema"],
    questionnaire: {
      id: "6f090a20-04e5-41c9-97a2-771bf856b53e",
      identifier: [
        {
          system: "http://clinical_trial_agent.com",
          value: "orie-devs-o7p2k-clinical-trial-agent",
        },
      ],
      item: [
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString: "¿Cuál es su nombre completo?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString: "Por favor, escriba su nombre y apellido.",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString: "Please enter your first and last name.",
            },
          ],
          linkId: "subject-fullName",
          text: "What is your full name?",
          type: "string",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString: "¿Cuál es su fecha de nacimiento?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString: "MM / DD / AAAA",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString: "MM / DD / YYYY",
            },
          ],
          linkId: "subject-dateOfBirth",
          text: "What is your date of birth?",
          type: "date",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString:
                      "¿Cuál es su dirección y ciudad (según aparece en su identificación válida)?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString:
                    "Por favor, proporcione su dirección y ciudad tal como aparece en su identificación válida.",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString:
                "Please provide your street address and city as listed on your valid ID.",
            },
          ],
          linkId: "subject-address-streetAndCity",
          text: "What is your Street address and City (as listed on valid ID)?",
          type: "string",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString: "¿Cuál es su estado?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString: "Por favor, proporcione el nombre de su estado.",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString: "Please provide the name of your state.",
            },
          ],
          linkId: "subject-address-state",
          text: "What is your State?",
          type: "string",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString: "¿Cuál es su código postal?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString: "Por favor, proporcione su código postal.",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString: "Please provide your zip code.",
            },
          ],
          linkId: "subject-address-zipCode",
          text: "What is your Zip Code?",
          type: "string",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString: "¿Está tomando algún medicamento actualmente?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString:
                    "Por favor, escriba todos los medicamentos que toma, incluyendo recetas y medicamentos de venta libre.",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString:
                "Please list all prescription and over-the-counter medications you are taking.",
            },
          ],
          linkId: "subject-medications-currentMedications",
          text: "Are you currently taking any medications?",
          type: "text",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString:
                      "¿Ha visitado un hospital o sala de emergencias recientemente?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString:
                    "Indique si ha visitado un hospital o sala de emergencias recientemente.",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString:
                "Indicate if you have visited a hospital or emergency room recently.",
            },
          ],
          linkId: "subject-hospitalVisits-recentVisit-or-emergencyRoom",
          text: "Have you visited a hospital or emergency room recently?",
          type: "boolean",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString: "¿Le han diagnosticado eczema?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          linkId: "subject-location-specific-medical-condition-eczema",
          text: "Have you been diagnosed with Eczema?",
          type: "string",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString: "¿Le han diagnosticado migraña pediátrica?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          linkId:
            "subject-location-specific-medical-condition-pediatric-migraine",
          text: "Have you been diagnosed with Pediatric Migraine?",
          type: "string",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString:
                      "¿Tiene alguna condición de salud actual o pasada? (Si le han diagnosticado cáncer, por favor especifique el estadio)",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString:
                    "Incluya condiciones crónicas (por ejemplo, diabetes, asma) y condiciones recientes o agudas (por ejemplo, infecciones, cirugías).",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString:
                "Include both chronic (e.g., diabetes, asthma) and recent or acute conditions (e.g., infections, surgeries).",
            },
          ],
          linkId: "subject-healthConditions-currentOrPastConditions",
          text: "Do you have any current or past health conditions? (If you have been diagnosed with cancer, please specify the stage)",
          type: "text",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString:
                      "¿Le gustaría programar una cita con nosotros?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString:
                    "Indíquenos si le gustaría programar una consulta médica.",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString:
                "Let us know if you'd like to set up a consultation.",
            },
          ],
          linkId: "subject-appointment-requestAppointment",
          text: "Would you like to schedule an appointment with us?",
          type: "boolean",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString:
                      "Si es así, por favor proporcione una fecha y hora para la cita",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          enableWhen: [
            {
              answerBoolean: true,
              operator: "=",
              question: "subject-appointment-requestAppointment",
            },
          ],
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString:
                    "Proporcione la fecha y hora preferidas para la cita.",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString: "Specify the date and time you are available.",
            },
          ],
          linkId: "subject-appointment-preferredDateTime",
          text: "If yes, please provide a date and time for the appointment",
          type: "dateTime",
        },
      ],
      meta: {
        extension: [
          {
            url: "http://enliv.com/extensions/meta/user-info",
            valueString:
              '{"uid":"XRR8CdfmkIeBpWtIXt0yg3WoECS2","name":"Orie Devs","email":"dev.orie@yopmail.com"}',
          },
        ],
        lastUpdated: "2025-11-21T10:51:41.958443+00:00",
        source: "XRR8CdfmkIeBpWtIXt0yg3WoECS2",
        tag: [
          {
            code: "Location/d587f831-b0b9-4f49-816d-814167fa57b4",
            system: "http://clinical_trial_agent.com/tags/location",
          },
        ],
        versionId: "MTc2MzcyMjMwMTk1ODQ0MzAwMA",
      },
      name: "clinical_trial_questionnaire",
      resourceType: "Questionnaire",
      status: "active",
      title: "Discovery Clinical Trials Intake Form",
      url: "http://example.org/fhir/Questionnaire/clinical_trial_form/dev/2",
      version: "001",
    },
  },
  {
    locationName: "Stone Oak Site",
    city: "San Antonio",
    locationId: "d587f831-b0b9-4f49-816d-814167fa57b4",
    questionnaireId: "6f090a20-04e5-41c9-97a2-771bf856b53e",
    study: "Pediatric Migraine",
    studies: ["Pediatric Migraine", "Eczema"],
    questionnaire: {
      id: "6f090a20-04e5-41c9-97a2-771bf856b53e",
      identifier: [
        {
          system: "http://clinical_trial_agent.com",
          value: "orie-devs-o7p2k-clinical-trial-agent",
        },
      ],
      item: [
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString: "¿Cuál es su nombre completo?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString: "Por favor, escriba su nombre y apellido.",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString: "Please enter your first and last name.",
            },
          ],
          linkId: "subject-fullName",
          text: "What is your full name?",
          type: "string",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString: "¿Cuál es su fecha de nacimiento?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString: "MM / DD / AAAA",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString: "MM / DD / YYYY",
            },
          ],
          linkId: "subject-dateOfBirth",
          text: "What is your date of birth?",
          type: "date",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString:
                      "¿Cuál es su dirección y ciudad (según aparece en su identificación válida)?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString:
                    "Por favor, proporcione su dirección y ciudad tal como aparece en su identificación válida.",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString:
                "Please provide your street address and city as listed on your valid ID.",
            },
          ],
          linkId: "subject-address-streetAndCity",
          text: "What is your Street address and City (as listed on valid ID)?",
          type: "string",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString: "¿Cuál es su estado?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString: "Por favor, proporcione el nombre de su estado.",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString: "Please provide the name of your state.",
            },
          ],
          linkId: "subject-address-state",
          text: "What is your State?",
          type: "string",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString: "¿Cuál es su código postal?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString: "Por favor, proporcione su código postal.",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString: "Please provide your zip code.",
            },
          ],
          linkId: "subject-address-zipCode",
          text: "What is your Zip Code?",
          type: "string",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString: "¿Está tomando algún medicamento actualmente?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString:
                    "Por favor, escriba todos los medicamentos que toma, incluyendo recetas y medicamentos de venta libre.",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString:
                "Please list all prescription and over-the-counter medications you are taking.",
            },
          ],
          linkId: "subject-medications-currentMedications",
          text: "Are you currently taking any medications?",
          type: "text",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString:
                      "¿Ha visitado un hospital o sala de emergencias recientemente?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString:
                    "Indique si ha visitado un hospital o sala de emergencias recientemente.",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString:
                "Indicate if you have visited a hospital or emergency room recently.",
            },
          ],
          linkId: "subject-hospitalVisits-recentVisit-or-emergencyRoom",
          text: "Have you visited a hospital or emergency room recently?",
          type: "boolean",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString: "¿Le han diagnosticado eczema?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          linkId: "subject-location-specific-medical-condition-eczema",
          text: "Have you been diagnosed with Eczema?",
          type: "string",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString: "¿Le han diagnosticado migraña pediátrica?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          linkId:
            "subject-location-specific-medical-condition-pediatric-migraine",
          text: "Have you been diagnosed with Pediatric Migraine?",
          type: "string",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString:
                      "¿Tiene alguna condición de salud actual o pasada? (Si le han diagnosticado cáncer, por favor especifique el estadio)",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString:
                    "Incluya condiciones crónicas (por ejemplo, diabetes, asma) y condiciones recientes o agudas (por ejemplo, infecciones, cirugías).",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString:
                "Include both chronic (e.g., diabetes, asthma) and recent or acute conditions (e.g., infections, surgeries).",
            },
          ],
          linkId: "subject-healthConditions-currentOrPastConditions",
          text: "Do you have any current or past health conditions? (If you have been diagnosed with cancer, please specify the stage)",
          type: "text",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString:
                      "¿Le gustaría programar una cita con nosotros?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString:
                    "Indíquenos si le gustaría programar una consulta médica.",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString:
                "Let us know if you'd like to set up a consultation.",
            },
          ],
          linkId: "subject-appointment-requestAppointment",
          text: "Would you like to schedule an appointment with us?",
          type: "boolean",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString:
                      "Si es así, por favor proporcione una fecha y hora para la cita",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          enableWhen: [
            {
              answerBoolean: true,
              operator: "=",
              question: "subject-appointment-requestAppointment",
            },
          ],
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString:
                    "Proporcione la fecha y hora preferidas para la cita.",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString: "Specify the date and time you are available.",
            },
          ],
          linkId: "subject-appointment-preferredDateTime",
          text: "If yes, please provide a date and time for the appointment",
          type: "dateTime",
        },
      ],
      meta: {
        extension: [
          {
            url: "http://enliv.com/extensions/meta/user-info",
            valueString:
              '{"uid":"XRR8CdfmkIeBpWtIXt0yg3WoECS2","name":"Orie Devs","email":"dev.orie@yopmail.com"}',
          },
        ],
        lastUpdated: "2025-11-21T10:51:41.958443+00:00",
        source: "XRR8CdfmkIeBpWtIXt0yg3WoECS2",
        tag: [
          {
            code: "Location/d587f831-b0b9-4f49-816d-814167fa57b4",
            system: "http://clinical_trial_agent.com/tags/location",
          },
        ],
        versionId: "MTc2MzcyMjMwMTk1ODQ0MzAwMA",
      },
      name: "clinical_trial_questionnaire",
      resourceType: "Questionnaire",
      status: "active",
      title: "Discovery Clinical Trials Intake Form",
      url: "http://example.org/fhir/Questionnaire/clinical_trial_form/dev/2",
      version: "001",
    },
  },
  {
    locationName: "McAllen Site",
    city: "McAllen",
    locationId: "99e1d626-61c8-4baa-81fc-39e4f45cbfc9",
    questionnaireId: "9bdded1c-75d4-469f-a554-2fe6d02d375b",
    study: "COPD",
    studies:["Cardiovascular (Heart Attack, Stroke)","Asthma","COPD"],
    questionnaire: {
      id: "9bdded1c-75d4-469f-a554-2fe6d02d375b",
      identifier: [
        {
          system: "http://clinical_trial_agent.com",
          value: "orie-devs-o7p2k-clinical-trial-agent",
        },
      ],
      item: [
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString: "¿Cuál es su nombre completo?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString: "Por favor, escriba su nombre y apellido.",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString: "Please enter your first and last name.",
            },
          ],
          linkId: "subject-fullName",
          text: "What is your full name?",
          type: "string",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString: "¿Cuál es su fecha de nacimiento?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString: "MM / DD / AAAA",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString: "MM / DD / YYYY",
            },
          ],
          linkId: "subject-dateOfBirth",
          text: "What is your date of birth?",
          type: "date",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString:
                      "¿Cuál es su dirección y ciudad (según aparece en su identificación válida)?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString:
                    "Por favor, proporcione su dirección y ciudad tal como aparece en su identificación válida.",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString:
                "Please provide your street address and city as listed on your valid ID.",
            },
          ],
          linkId: "subject-address-streetAndCity",
          text: "What is your Street address and City (as listed on valid ID)?",
          type: "string",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString: "¿Cuál es su estado?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString: "Por favor, proporcione el nombre de su estado.",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString: "Please provide the name of your state.",
            },
          ],
          linkId: "subject-address-state",
          text: "What is your State?",
          type: "string",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString: "¿Cuál es su código postal?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString: "Por favor, proporcione su código postal.",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString: "Please provide your zip code.",
            },
          ],
          linkId: "subject-address-zipCode",
          text: "What is your Zip Code?",
          type: "string",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString: "¿Está tomando algún medicamento actualmente?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString:
                    "Por favor, escriba todos los medicamentos que toma, incluyendo recetas y medicamentos de venta libre.",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString:
                "Please list all prescription and over-the-counter medications you are taking.",
            },
          ],
          linkId: "subject-medications-currentMedications",
          text: "Are you currently taking any medications?",
          type: "text",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString:
                      "¿Ha visitado un hospital o sala de emergencias recientemente?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString:
                    "Indique si ha visitado un hospital o sala de emergencias recientemente.",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString:
                "Indicate if you have visited a hospital or emergency room recently.",
            },
          ],
          linkId: "subject-hospitalVisits-recentVisit-or-emergencyRoom",
          text: "Have you visited a hospital or emergency room recently?",
          type: "boolean",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString:
                      "¿Sufre de alguna condición cardiovascular, como un ataque al corazón o un derrame cerebral?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          linkId:
            "subject-location-specific-medical-condition-cardiovascular-conditions",
          text: "Do you suffer from any cardiovascular conditions, such as a heart attack or stroke?",
          type: "string",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString: "¿Sufre de asma?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          linkId: "subject-location-specific-medical-condition-asthma",
          text: "Do you suffer from Asthma?",
          type: "string",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString: "¿Sufre de EPOC?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          linkId: "subject-location-specific-medical-condition-copd",
          text: "Do you suffer from COPD?",
          type: "string",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString:
                      "¿Tiene alguna condición de salud actual o pasada? (Si le han diagnosticado cáncer, por favor especifique el estadio)",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString:
                    "Incluya condiciones crónicas (por ejemplo, diabetes, asma) y condiciones recientes o agudas (por ejemplo, infecciones, cirugías).",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString:
                "Include both chronic (e.g., diabetes, asthma) and recent or acute conditions (e.g., infections, surgeries).",
            },
          ],
          linkId: "subject-healthConditions-currentOrPastConditions",
          text: "Do you have any current or past health conditions? (If you have been diagnosed with cancer, please specify the stage)",
          type: "text",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString:
                      "¿Le gustaría programar una cita con nosotros?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString:
                    "Indíquenos si le gustaría programar una consulta médica.",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString:
                "Let us know if you'd like to set up a consultation.",
            },
          ],
          linkId: "subject-appointment-requestAppointment",
          text: "Would you like to schedule an appointment with us?",
          type: "boolean",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString:
                      "Si es así, por favor proporcione una fecha y hora para la cita",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          enableWhen: [
            {
              answerBoolean: true,
              operator: "=",
              question: "subject-appointment-requestAppointment",
            },
          ],
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString:
                    "Proporcione la fecha y hora preferidas para la cita.",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString: "Specify the date and time you are available.",
            },
          ],
          linkId: "subject-appointment-preferredDateTime",
          text: "If yes, please provide a date and time for the appointment",
          type: "dateTime",
        },
      ],
      meta: {
        extension: [
          {
            url: "http://enliv.com/extensions/meta/user-info",
            valueString:
              '{"uid":"XRR8CdfmkIeBpWtIXt0yg3WoECS2","name":"Orie Devs","email":"dev.orie@yopmail.com"}',
          },
        ],
        lastUpdated: "2025-11-21T10:56:15.350422+00:00",
        source: "XRR8CdfmkIeBpWtIXt0yg3WoECS2",
        tag: [
          {
            code: "Location/99e1d626-61c8-4baa-81fc-39e4f45cbfc9",
            system: "http://clinical_trial_agent.com/tags/location",
          },
        ],
        versionId: "MTc2MzcyMjU3NTM1MDQyMjAwMA",
      },
      name: "clinical_trial_questionnaire",
      resourceType: "Questionnaire",
      status: "active",
      title: "Discovery Clinical Trials Intake Form",
      url: "http://example.org/fhir/Questionnaire/clinical_trial_form/dev/3",
      version: "001",
    },
  },
  {
    locationName: "McAllen Site",
    city: "McAllen",
    locationId: "99e1d626-61c8-4baa-81fc-39e4f45cbfc9",
    questionnaireId: "9bdded1c-75d4-469f-a554-2fe6d02d375b",
    study: "Asthma",
    studies:["Cardiovascular (Heart Attack, Stroke)","Asthma","COPD"],
    questionnaire: {
      id: "9bdded1c-75d4-469f-a554-2fe6d02d375b",
      identifier: [
        {
          system: "http://clinical_trial_agent.com",
          value: "orie-devs-o7p2k-clinical-trial-agent",
        },
      ],
      item: [
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString: "¿Cuál es su nombre completo?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString: "Por favor, escriba su nombre y apellido.",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString: "Please enter your first and last name.",
            },
          ],
          linkId: "subject-fullName",
          text: "What is your full name?",
          type: "string",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString: "¿Cuál es su fecha de nacimiento?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString: "MM / DD / AAAA",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString: "MM / DD / YYYY",
            },
          ],
          linkId: "subject-dateOfBirth",
          text: "What is your date of birth?",
          type: "date",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString:
                      "¿Cuál es su dirección y ciudad (según aparece en su identificación válida)?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString:
                    "Por favor, proporcione su dirección y ciudad tal como aparece en su identificación válida.",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString:
                "Please provide your street address and city as listed on your valid ID.",
            },
          ],
          linkId: "subject-address-streetAndCity",
          text: "What is your Street address and City (as listed on valid ID)?",
          type: "string",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString: "¿Cuál es su estado?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString: "Por favor, proporcione el nombre de su estado.",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString: "Please provide the name of your state.",
            },
          ],
          linkId: "subject-address-state",
          text: "What is your State?",
          type: "string",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString: "¿Cuál es su código postal?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString: "Por favor, proporcione su código postal.",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString: "Please provide your zip code.",
            },
          ],
          linkId: "subject-address-zipCode",
          text: "What is your Zip Code?",
          type: "string",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString: "¿Está tomando algún medicamento actualmente?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString:
                    "Por favor, escriba todos los medicamentos que toma, incluyendo recetas y medicamentos de venta libre.",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString:
                "Please list all prescription and over-the-counter medications you are taking.",
            },
          ],
          linkId: "subject-medications-currentMedications",
          text: "Are you currently taking any medications?",
          type: "text",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString:
                      "¿Ha visitado un hospital o sala de emergencias recientemente?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString:
                    "Indique si ha visitado un hospital o sala de emergencias recientemente.",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString:
                "Indicate if you have visited a hospital or emergency room recently.",
            },
          ],
          linkId: "subject-hospitalVisits-recentVisit-or-emergencyRoom",
          text: "Have you visited a hospital or emergency room recently?",
          type: "boolean",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString:
                      "¿Sufre de alguna condición cardiovascular, como un ataque al corazón o un derrame cerebral?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          linkId:
            "subject-location-specific-medical-condition-cardiovascular-conditions",
          text: "Do you suffer from any cardiovascular conditions, such as a heart attack or stroke?",
          type: "string",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString: "¿Sufre de asma?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          linkId: "subject-location-specific-medical-condition-asthma",
          text: "Do you suffer from Asthma?",
          type: "string",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString: "¿Sufre de EPOC?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          linkId: "subject-location-specific-medical-condition-copd",
          text: "Do you suffer from COPD?",
          type: "string",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString:
                      "¿Tiene alguna condición de salud actual o pasada? (Si le han diagnosticado cáncer, por favor especifique el estadio)",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString:
                    "Incluya condiciones crónicas (por ejemplo, diabetes, asma) y condiciones recientes o agudas (por ejemplo, infecciones, cirugías).",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString:
                "Include both chronic (e.g., diabetes, asthma) and recent or acute conditions (e.g., infections, surgeries).",
            },
          ],
          linkId: "subject-healthConditions-currentOrPastConditions",
          text: "Do you have any current or past health conditions? (If you have been diagnosed with cancer, please specify the stage)",
          type: "text",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString:
                      "¿Le gustaría programar una cita con nosotros?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString:
                    "Indíquenos si le gustaría programar una consulta médica.",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString:
                "Let us know if you'd like to set up a consultation.",
            },
          ],
          linkId: "subject-appointment-requestAppointment",
          text: "Would you like to schedule an appointment with us?",
          type: "boolean",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString:
                      "Si es así, por favor proporcione una fecha y hora para la cita",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          enableWhen: [
            {
              answerBoolean: true,
              operator: "=",
              question: "subject-appointment-requestAppointment",
            },
          ],
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString:
                    "Proporcione la fecha y hora preferidas para la cita.",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString: "Specify the date and time you are available.",
            },
          ],
          linkId: "subject-appointment-preferredDateTime",
          text: "If yes, please provide a date and time for the appointment",
          type: "dateTime",
        },
      ],
      meta: {
        extension: [
          {
            url: "http://enliv.com/extensions/meta/user-info",
            valueString:
              '{"uid":"XRR8CdfmkIeBpWtIXt0yg3WoECS2","name":"Orie Devs","email":"dev.orie@yopmail.com"}',
          },
        ],
        lastUpdated: "2025-11-21T10:56:15.350422+00:00",
        source: "XRR8CdfmkIeBpWtIXt0yg3WoECS2",
        tag: [
          {
            code: "Location/99e1d626-61c8-4baa-81fc-39e4f45cbfc9",
            system: "http://clinical_trial_agent.com/tags/location",
          },
        ],
        versionId: "MTc2MzcyMjU3NTM1MDQyMjAwMA",
      },
      name: "clinical_trial_questionnaire",
      resourceType: "Questionnaire",
      status: "active",
      title: "Discovery Clinical Trials Intake Form",
      url: "http://example.org/fhir/Questionnaire/clinical_trial_form/dev/3",
      version: "001",
    },
  },
  {
    locationName: "McAllen Site",
    city: "McAllen",
    locationId: "99e1d626-61c8-4baa-81fc-39e4f45cbfc9",
    questionnaireId: "9bdded1c-75d4-469f-a554-2fe6d02d375b",
    study: "Cardiovascular (Heart Attack, Stroke)",
    studies:["Cardiovascular (Heart Attack, Stroke)","Asthma","COPD"],
    questionnaire: {
      id: "9bdded1c-75d4-469f-a554-2fe6d02d375b",
      identifier: [
        {
          system: "http://clinical_trial_agent.com",
          value: "orie-devs-o7p2k-clinical-trial-agent",
        },
      ],
      item: [
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString: "¿Cuál es su nombre completo?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString: "Por favor, escriba su nombre y apellido.",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString: "Please enter your first and last name.",
            },
          ],
          linkId: "subject-fullName",
          text: "What is your full name?",
          type: "string",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString: "¿Cuál es su fecha de nacimiento?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString: "MM / DD / AAAA",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString: "MM / DD / YYYY",
            },
          ],
          linkId: "subject-dateOfBirth",
          text: "What is your date of birth?",
          type: "date",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString:
                      "¿Cuál es su dirección y ciudad (según aparece en su identificación válida)?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString:
                    "Por favor, proporcione su dirección y ciudad tal como aparece en su identificación válida.",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString:
                "Please provide your street address and city as listed on your valid ID.",
            },
          ],
          linkId: "subject-address-streetAndCity",
          text: "What is your Street address and City (as listed on valid ID)?",
          type: "string",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString: "¿Cuál es su estado?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString: "Por favor, proporcione el nombre de su estado.",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString: "Please provide the name of your state.",
            },
          ],
          linkId: "subject-address-state",
          text: "What is your State?",
          type: "string",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString: "¿Cuál es su código postal?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString: "Por favor, proporcione su código postal.",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString: "Please provide your zip code.",
            },
          ],
          linkId: "subject-address-zipCode",
          text: "What is your Zip Code?",
          type: "string",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString: "¿Está tomando algún medicamento actualmente?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString:
                    "Por favor, escriba todos los medicamentos que toma, incluyendo recetas y medicamentos de venta libre.",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString:
                "Please list all prescription and over-the-counter medications you are taking.",
            },
          ],
          linkId: "subject-medications-currentMedications",
          text: "Are you currently taking any medications?",
          type: "text",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString:
                      "¿Ha visitado un hospital o sala de emergencias recientemente?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString:
                    "Indique si ha visitado un hospital o sala de emergencias recientemente.",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString:
                "Indicate if you have visited a hospital or emergency room recently.",
            },
          ],
          linkId: "subject-hospitalVisits-recentVisit-or-emergencyRoom",
          text: "Have you visited a hospital or emergency room recently?",
          type: "boolean",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString:
                      "¿Sufre de alguna condición cardiovascular, como un ataque al corazón o un derrame cerebral?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          linkId:
            "subject-location-specific-medical-condition-cardiovascular-conditions",
          text: "Do you suffer from any cardiovascular conditions, such as a heart attack or stroke?",
          type: "string",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString: "¿Sufre de asma?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          linkId: "subject-location-specific-medical-condition-asthma",
          text: "Do you suffer from Asthma?",
          type: "string",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString: "¿Sufre de EPOC?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          linkId: "subject-location-specific-medical-condition-copd",
          text: "Do you suffer from COPD?",
          type: "string",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString:
                      "¿Tiene alguna condición de salud actual o pasada? (Si le han diagnosticado cáncer, por favor especifique el estadio)",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString:
                    "Incluya condiciones crónicas (por ejemplo, diabetes, asma) y condiciones recientes o agudas (por ejemplo, infecciones, cirugías).",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString:
                "Include both chronic (e.g., diabetes, asthma) and recent or acute conditions (e.g., infections, surgeries).",
            },
          ],
          linkId: "subject-healthConditions-currentOrPastConditions",
          text: "Do you have any current or past health conditions? (If you have been diagnosed with cancer, please specify the stage)",
          type: "text",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString:
                      "¿Le gustaría programar una cita con nosotros?",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString:
                    "Indíquenos si le gustaría programar una consulta médica.",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString:
                "Let us know if you'd like to set up a consultation.",
            },
          ],
          linkId: "subject-appointment-requestAppointment",
          text: "Would you like to schedule an appointment with us?",
          type: "boolean",
        },
        {
          _text: {
            extension: [
              {
                extension: [
                  {
                    url: "lang",
                    valueCode: "es",
                  },
                  {
                    url: "content",
                    valueString:
                      "Si es así, por favor proporcione una fecha y hora para la cita",
                  },
                ],
                url: "http://hl7.org/fhir/StructureDefinition/translation",
              },
            ],
          },
          enableWhen: [
            {
              answerBoolean: true,
              operator: "=",
              question: "subject-appointment-requestAppointment",
            },
          ],
          extension: [
            {
              extension: [
                {
                  url: "lang",
                  valueCode: "es",
                },
                {
                  url: "content",
                  valueString:
                    "Proporcione la fecha y hora preferidas para la cita.",
                },
              ],
              url: "http://example.org/fhir/StructureDefinition/item-help",
              valueString: "Specify the date and time you are available.",
            },
          ],
          linkId: "subject-appointment-preferredDateTime",
          text: "If yes, please provide a date and time for the appointment",
          type: "dateTime",
        },
      ],
      meta: {
        extension: [
          {
            url: "http://enliv.com/extensions/meta/user-info",
            valueString:
              '{"uid":"XRR8CdfmkIeBpWtIXt0yg3WoECS2","name":"Orie Devs","email":"dev.orie@yopmail.com"}',
          },
        ],
        lastUpdated: "2025-11-21T10:56:15.350422+00:00",
        source: "XRR8CdfmkIeBpWtIXt0yg3WoECS2",
        tag: [
          {
            code: "Location/99e1d626-61c8-4baa-81fc-39e4f45cbfc9",
            system: "http://clinical_trial_agent.com/tags/location",
          },
        ],
        versionId: "MTc2MzcyMjU3NTM1MDQyMjAwMA",
      },
      name: "clinical_trial_questionnaire",
      resourceType: "Questionnaire",
      status: "active",
      title: "Discovery Clinical Trials Intake Form",
      url: "http://example.org/fhir/Questionnaire/clinical_trial_form/dev/3",
      version: "001",
    },
  },
];

	const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance();
	
	export const formatToE164 = (phoneNumber) => {
  try {
    const parsedNumber = phoneUtil.parse(phoneNumber); // works if input has '+' prefix
    if (phoneUtil.isValidNumber(parsedNumber)) {
      return phoneUtil.format(parsedNumber, PhoneNumberFormat.E164);
    }
    return null;
  } catch {
    return null;
  }
};